import {tns} from 'tiny-slider/src/tiny-slider';

import common from './../module/common';
import Config from "../../assets/js/config";

const config = new Config();

const $root = $('html, body');

const addClass = (element, className) => {
    common.addClass(element, className);
};

const removeClass = (element, className) => {
    common.removeClass(element, className);
};

function getChevronIcons() {
    return [
        "<svg class='icon-chevron-left'><use xlink:href='" + config.getDomain() + "/svg/icons.svg#icon-chevron-left'></use></svg>",
        "<svg class='icon-chevron-right'><use xlink:href='" + config.getDomain() + "/svg/icons.svg#icon-chevron-right'></use></svg>"
    ];
}

export function scrollToElement(el) {
    if (el) {
        const headerHeight = $('#header').height();
        const elementPosition = $(el).offset().top;
        const inputHeight = 75;

        $('html, body').animate({
            scrollTop: elementPosition - headerHeight - inputHeight,
        }, 1000);
    }
};

export default {
    scrollTop: () => {
        setTimeout(function () {
            $root.stop().animate({scrollTop: 0}, 500, 'swing');
        }, 1000);
    },
    moveToProductNav: () => {
        let distanceToTop;
        let dataTarget;
        let navArr = [
            '#productomschrijving',
            '#vraag-en-antwoord',
            '#beoordelingen',
            '#aanbevolen-combinaties',
            '#klantenservice'
        ];

        const mq = window.matchMedia('(max-width: 1024px)');

        const currentNav = navArr.find(function (nav) {
            return window.location.href.indexOf(nav) !== -1 || window.location.href.indexOf(nav.replace('#', '')) !== -1
        });

        if (currentNav) {
            dataTarget = document.querySelector(currentNav);

            if (!mq.matches && currentNav === '#aanbevolen-combinaties') {
                distanceToTop = dataTarget.offsetTop + 200;
            } else {
                distanceToTop = dataTarget.offsetTop;
            }

            if (dataTarget) {
                $root.animate({scrollTop: distanceToTop}, 500);
            }
        }
    },
    moveToQuestion: () => {
        let lengthOfParam = '#productQuestion'.length;
        let questionId = window.location.href.substr(window.location.href.indexOf('#productQuestion') + lengthOfParam, window.location.href.length);
        let questionJQ = $(`#${questionId}`);

        $root.animate({scrollTop: questionJQ[0].offsetTop - 200}, 1000);
    },
    showMainBlock: () => {
        const $vueComponent = $('#vueComponent');
        const $spinner = $('.spinner');
        const $footer = $('.js_footer');
        const $footerUspbar = $('.js_footer-uspbar');
        const $vendorPageContent = $('.vendorPageContent .stickyWrapper');

        $spinner.addClass('hidden');
        $vueComponent.animate({'opacity': '1'}, 1000, '', () => {
            $vendorPageContent.removeClass('invisible');
            $footer.add($footerUspbar).removeClass('invisible');
        });
    },
    navigation() {
        const headerHeight = document.querySelector('header').clientHeight;
        const scrollToggle = document.querySelectorAll('.js_scrollTo');
        const anchors = document.querySelectorAll('.anchorMenu ul a');
        const anchorHrefs = [];

        let timeoutId;

        var smoothScroll = function (anchor, duration) {
            let floatBuyButton = $('.floatBuyButton');
            let mq = window.matchMedia( "(max-width: 740px)" );
            let hrOffset = $('hr').outerHeight(true);

            floatBuyButton = floatBuyButton[0] ? floatBuyButton[0].clientHeight : 0;

            if (anchor) {
                if (mq.matches) {
                    $root.animate({scrollTop: anchor.offsetTop - headerHeight * 2}, 1000);
                } else {
                    $root.animate({scrollTop: anchor.offsetTop + headerHeight - floatBuyButton - hrOffset}, 1000);
                }
            }
        };

        // For each smooth scroll link
        [].forEach.call(scrollToggle, function (toggle) {
            // When the smooth scroll link is clicked
            toggle.addEventListener('click', function (evt) {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }

                evt.preventDefault();

                timeoutId = setTimeout(function () {
                    //setTimeout to forbid endless invokes of theevent
                    // Get anchor link and calculate distance from the top
                    var dataID = toggle.getAttribute('href');
                    var dataTarget = document.querySelector(dataID);
                    var dataSpeed = toggle.getAttribute('data-speed');

                    // If the anchor exists
                    if (dataTarget) {
                        // Scroll to the anchor
                        smoothScroll(dataTarget, dataSpeed || 500);
                    }
                }, 300);
            }, false);
        });

        // Push anchor's hrefs into the array
        for (var i = 0; i < anchors.length; i++) {
            const anchor = anchors[i];
            const ahref = anchor.getAttribute('href');

            anchorHrefs.push(ahref);
        }

        // Functions to call when user scrolls
        window.onscroll = function () {
            const scrollPosition = window.pageYOffset;
            const headerOffset = headerHeight * 2;

            for (var i = 0; i < anchorHrefs.length; i++) {
                // Loop over anchor's href tags and set classes
                if (!document.querySelector(anchorHrefs[i])) {
                    continue;
                }

                var theID = anchorHrefs[i],
                    divTop = document.querySelector(theID).offsetTop - headerOffset,
                    divHeight = document.querySelector(theID).offsetHeight

                if (scrollPosition >= divTop && scrollPosition < (divTop + divHeight)) {
                    addClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
                } else {
                    removeClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
                }
            }
        }

        if (window.location.href.indexOf('#') >= 0) {
            const anchor = window.location.href.split('#')[1];
            if (!anchor.length) {
                history.replaceState({}, '', window.location.href.replace('#', ''));
                return;
            }
            const el = document.querySelector('#' + anchor);

            smoothScroll(el, 1000);
        }
    },
    bannersSlider() {
        const heroSliderContainer = document.querySelector('.heroSlider');

        if (!heroSliderContainer || (heroSliderContainer && heroSliderContainer.firstElementChild.classList.contains('tns-outer'))) {
            return;
        }

        const firstSlide = heroSliderContainer.querySelector('.singleSlide');

        const heroSlider = tns({
            container: '.heroSlider .slides',
            mode: 'carousel',
            controlsText: getChevronIcons(),
            loop: true,
            autoplay: true,
            speed: 550,
            onInit(info) {
                if (firstSlide.querySelector('video')) {
                    firstSlide.querySelector('video').play();
                }

                // Remove tns tabindex from controls to allow navigation only with nav
                info.controlsContainer.setAttribute('tabindex', '-1');

                // Avoid focus on cloned slides to avoid repeated focus events
                const clonedSlidesFocusable = info.container.querySelectorAll('.tns-slide-cloned a, .tns-slide-cloned button');
                clonedSlidesFocusable.forEach((el) => el.setAttribute('tabindex', '-1'));
            },
        });

        // function to call before slide changes
        function beforeChange() {
            const curSlide = heroSliderContainer.querySelector('.tns-slide-active');

            if (curSlide.querySelector('video')) {
                curSlide.querySelector('video').pause();
            }
        }

        // function to call after slide changes
        function afterChange() {
            setTimeout(function() {
                const curSlide = heroSliderContainer.querySelector('.tns-slide-active');

                if (curSlide.querySelector('video')) {
                    curSlide.querySelector('video').play();
                }
            }, 100);
        }

        function onIndexChange(info) {
            Array.from(info.slideItems).forEach((slide, index) => {
                // Make inert. tns tabIndex doesn't work because it's descendants can be focused)
                slide.inert = true;
            })

            const activeSlide = info.slideItems[info.index];
            activeSlide.inert = false;
        }

        if (heroSlider) {
            heroSlider.events.on('transitionStart', beforeChange);
            heroSlider.events.on('transitionEnd', afterChange);
            heroSlider.events.on('indexChanged', onIndexChange);
        }
    },

    productSliderZoom(sliders, numberOfSliders = 5) {
        return import('drift-zoom')
            .then((module) => {
                const Drift = module.default;

                sliders.productSliderMain = tns({
                    container: '.js_product-slider',
                    controlsText: getChevronIcons(),
                    loop: true,
                    speed: 500,
                    navContainer: '#productSlider-control',
                    lazyload: true,
                });

                sliders.productSliderControl = tns({
                    container: '#productSlider-control',
                    items: numberOfSliders,
                    controlsText: getChevronIcons(),
                    loop: false,
                    speed: 500,
                });

                const allZoomables = document.querySelectorAll('.imageZoom-wrapper');

                for (let i = 0; i < allZoomables.length; i++) {
                    new Drift(allZoomables[i].querySelector('.imageZoom'), {
                        paneContainer: allZoomables[i].querySelector('.imageZoom-detail'),
                        zoomFactor: 2,
                        sourceAttribute: 'data-zoom',
                    });
                }
            });
    },
    productSwiper: (sliders) => {
        import('swiper/bundle')
            .then((module) => {
                const Swiper = module.default;

                sliders.productSliderMain = new Swiper('.swiper-main-slider', {
                    spaceBetween: 10,
                    zoom: true,
                    centeredSlides: true,
                    roundLengths: true,
                    grabCursor: true,
                    threshold: 3,
                    simulateTouch: false,
                    watchSlidesProgress: true,
                });

                sliders.productSliderMain.on('slideChange', function () {
                    $('#image-number').text(this.activeIndex + 1);
                });
            });
    },
    getVideoLink(video) {
        let link = '';

        if (!isNaN(parseFloat(video)) && isFinite(video)) {
            link = `//player.vimeo.com/video/${video}?title=0&byline=0&portrait=0&color=ff9933&autoplay=1&loop=1&autopause=0&background=1`;
        } else if ((typeof video === 'string') && video.substr(0, 2) === 'v:') {
            video = video.replace('v:', '');
            link = `//player.vimeo.com/video/${video}?title=0&byline=0&portrait=0&color=ff9933&autoplay=1&loop=1&autopause=0&background=1`;
        } else {
            link = `https://www.youtube.com/embed/${video}?rel=0&wmode=transparent&html5=1`;
        }

        return link;
    },
    scrollTo(target, offcetTop, duration) {
        let element = document.querySelector(target);

        if (element === null) {
            return;
        }

        let offset = element.offsetTop - offcetTop;

        $root.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
            $root.stop();
        });

        $root.animate({scrollTop: offset}, duration), function () {
            $root.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
        };
    },
}
